import { render, staticRenderFns } from "./AddTicket.vue?vue&type=template&id=1667cf6b&scoped=true"
import script from "./AddTicket.vue?vue&type=script&lang=js"
export * from "./AddTicket.vue?vue&type=script&lang=js"
import style0 from "./AddTicket.vue?vue&type=style&index=0&id=1667cf6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1667cf6b",
  null
  
)

export default component.exports